export const SepaCountries = () => {
  const SepaCountryList = [
    {key: 'BE', value: 'app.card.section.address.country.BE'},
    {key: 'BG', value: 'app.card.section.address.country.BG'},
    {key: 'DK', value: 'app.card.section.address.country.DK'},
    {key: 'DE', value: 'app.card.section.address.country.DE'},
    {key: 'EE', value: 'app.card.section.address.country.EE'},
    {key: 'FI', value: 'app.card.section.address.country.FI'},
    {key: 'FR', value: 'app.card.section.address.country.FR'},
    {key: 'GR', value: 'app.card.section.address.country.GR'},
    {key: 'GB', value: 'app.card.section.address.country.GB'},
    {key: 'IE', value: 'app.card.section.address.country.IE'},
    {key: 'IS', value: 'app.card.section.address.country.IS'},
    {key: 'IT', value: 'app.card.section.address.country.IT'},
    {key: 'HR', value: 'app.card.section.address.country.HR'},
    {key: 'LV', value: 'app.card.section.address.country.LV'},
    {key: 'LI', value: 'app.card.section.address.country.LI'},
    {key: 'LT', value: 'app.card.section.address.country.LT'},
    {key: 'LU', value: 'app.card.section.address.country.LU'},
    {key: 'MT', value: 'app.card.section.address.country.MT'},
    {key: 'MC', value: 'app.card.section.address.country.MC'},
    {key: 'NL', value: 'app.card.section.address.country.NL'},
    {key: 'NO', value: 'app.card.section.address.country.NO'},
    {key: 'AT', value: 'app.card.section.address.country.AT'},
    {key: 'PL', value: 'app.card.section.address.country.PL'},
    {key: 'PT', value: 'app.card.section.address.country.PT'},
    {key: 'RO', value: 'app.card.section.address.country.RO'},
    {key: 'SE', value: 'app.card.section.address.country.SE'},
    {key: 'CH', value: 'app.card.section.address.country.CH'},
    {key: 'SK', value: 'app.card.section.address.country.SK'},
    {key: 'SI', value: 'app.card.section.address.country.SI'},
    {key: 'ES', value: 'app.card.section.address.country.ES'},
    {key: 'CZ', value: 'app.card.section.address.country.CZ'},
    {key: 'HU', value: 'app.card.section.address.country.HU'},
    {key: 'CY', value: 'app.card.section.address.country.CY'}
  ];

  const SepaCountries = [
    'BE',
    'BG',
    'DK',
    'DE',
    'EE',
    'FI',
    'FR',
    'GR',
    'GB',
    'IE',
    'IS',
    'IT',
    'HR',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MC',
    'NL',
    'NO',
    'AT',
    'PL',
    'PT',
    'RO',
    'SM',
    'SE',
    'CH',
    'SK',
    'SI',
    'ES',
    'CZ',
    'HU',
    'CY'];

  return {
    list: SepaCountries,
    keyValueList: SepaCountryList,
    selectables: {
      modelKey: 'key',
      orderKeys: false,
      searchEnabled: false,
      selectables: SepaCountryList
    },
    selectablesWithOptions(modelKey = 'key', searchEnabled = false, orderKeys = false) {
      return {
        modelKey,
        orderKeys,
        searchEnabled,
        selectables: SepaCountryList
      };
    }
  };
};

export default SepaCountries;
